var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVogoPosArrowNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70117 6.33105C6.70117 6.4541 6.67839 6.56803 6.63281 6.67285C6.5918 6.77767 6.51888 6.87793 6.41406 6.97363L1.41016 11.875C1.25521 12.0299 1.06608 12.1074 0.842773 12.1074C0.687826 12.1074 0.546549 12.071 0.418945 11.998C0.295898 11.9251 0.197917 11.8249 0.125 11.6973C0.0520833 11.5742 0.015625 11.4375 0.015625 11.2871C0.015625 11.0638 0.0999349 10.8656 0.268555 10.6924L4.74609 6.33105L0.268555 1.96973C0.0999349 1.79655 0.015625 1.59831 0.015625 1.375C0.015625 1.22005 0.0520833 1.08105 0.125 0.958008C0.197917 0.834961 0.295898 0.739258 0.418945 0.670898C0.546549 0.597982 0.687826 0.561523 0.842773 0.561523C1.06608 0.561523 1.25521 0.638997 1.41016 0.793945L6.41406 5.68848C6.51432 5.78418 6.58724 5.88444 6.63281 5.98926C6.67839 6.09408 6.70117 6.20801 6.70117 6.33105Z",
    fill: "#4A5561"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVogoPosArrowNext);
export default __webpack_public_path__ + "static/media/ic_vogo_pos_arrow_next.021598b72a5de684f2259f58cb0186d4.svg";
export { ForwardRef as ReactComponent };